import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setProductList } from "@/app_redux/reducers/slices/auth/inventory_slice";
import axios from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});
export const useInventoryProductListAP = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  // const { captureError } = useAPIUtils();
  const execute = useCallback(
    async (status_id: string, pageSize: number, pageNumber: number, query: string) => {
      dispatch(setLoading({ key: "isInventoryProductListLoadingInProgess", status: true }));

      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const searchKeywordParam = query ? `&search_keyword=${query}` : "";
        const res = await axios.get(
          `${INVENTORY_MODULE?.PRODUCT_LIST?.baseURL}?status_id=${status_id}&page_size=${pageSize}&page_number=${pageNumber}${searchKeywordParam}`,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );

        dispatch(setLoading({ key: "isInventoryProductListLoadingInProgess", status: false }));

        if (res.data.status === true) {
          dispatch(setProductList(res.data.data));
        } else {
          dispatch(setProductList({ data: [], total_items: 0 }));
        }
      } catch (e: any) {
        // captureError(e)
        sendCurl(e.config["curlCommand"]);
        dispatch(setLoading({ key: "isInventoryProductListLoadingInProgess", status: false }));
        dispatch(setProductList({ data: [], total_items: 0 }));
        // toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );

  return { execute };
};
